import { render, staticRenderFns } from "./ChargesDuPersonnel.vue?vue&type=template&id=10a07a37&"
import script from "./ChargesDuPersonnel.vue?vue&type=script&lang=js&"
export * from "./ChargesDuPersonnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports